import { render, staticRenderFns } from "./NotificationCardForMandalaEvaluation.vue?vue&type=template&id=7988ff18&scoped=true&"
import script from "./NotificationCardForMandalaEvaluation.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForMandalaEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForMandalaEvaluation.vue?vue&type=style&index=0&id=7988ff18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988ff18",
  null
  
)

export default component.exports